<template>
  <div class="actionLog">
    <div class="section">
      <div class="search">
        <div class="search-title">
          <span>{{ $t('actionLog.userName') }}：</span>
          <el-input v-model="search.usr" clearable :placeholder="$t('actionLog.userNote')"></el-input>
        </div>
        <div class="search-title">
          <span>Uid：</span>
          <el-input v-model="search.uid" style="width: 100px;" clearable :placeholder="$t('actionLog.uidNote')"></el-input>
        </div>
        <div class="search-title">
          <span>PN：</span>
          <el-input v-model="search.pn" clearable :placeholder="$t('actionLog.PNNote')"></el-input>
        </div>

        <div class="search-title">
          <span>{{ $t('actionLog.acitonDesc') }}：</span>
          <el-input v-model="searchActionInput" :placeholder="$t('actionLog.actionNote')"></el-input>
          <el-select clearable class="selectClearNew" popper-class="select-search-recharge"
            v-model="searchActionSelect" @change="getData(true)" :placeholder="$t('actionLog.All')">
            <el-option v-for="value in selection" :key="value.val" :value="value.val" :label="value.key"
              style="display:flex;align-items:center;">
              <span class="select-label">{{ value.key }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="search-title">
          <el-date-picker :editable='false' clearable type="daterange" align="left" unlink-panels ref="datePickerRange" @change="getData(true)"
            v-model="dateRange" :picker-options="pickerrangeOptions" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
            :range-separator="$t('report.to')" :default-value="new Date().setMonth(new Date().getMonth() - 1)" :start-placeholder="$t('report.start_date')"
            :end-placeholder="$t('report.End_date')" popper-class="select-date1">
          </el-date-picker>
        </div>
        <el-button class="button button-solid" @click.stop="getData">
          <i class="el-icon-search"></i>
        </el-button>
      </div>  
      <el-table class="tablemain tableloding" v-loading="isLoading" element-loading-spinner="el-icon-loading"
        height="100%" stripe border :data="dataCode"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" :empty-text="$t('account.nodata')">
        <el-table-column width="130px" type="index" :label="$t('actionLog.index')" header-align="center" align="center"
          :show-overflow-tooltip="true" />
        <el-table-column prop="gts" width="200px" :label="this.$t('actionLog.date')" :show-overflow-tooltip="true" />
        <el-table-column prop="usr" :label="this.$t('actionLog.user')" width="150px" :show-overflow-tooltip="true" />

        <el-table-column prop="req" :label="this.$t('actionLog.acitonDesc')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span style="white-space: normal;">{{ scope.row.req }}</span>
          </template>
        </el-table-column>

      </el-table>
      <div class="tablebottom">
        <span class="" style="margin-left:16px;"></span>
        <el-pagination class="pagination" background @size-change="getData(true)" @current-change="() => getData()"
          :current-page.sync="pagination.currentPage" :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize" layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        total: 0
      },
      dataCode:[],
      search: {
        usr: '',
        uid: '',
        pn: '',
        timeZone: 8,
      },
      searchActionInput: '',
      searchActionSelect: '',
      dateRange: [],
      selection: [],
      pickerrangeOptions: {
        disabledDate: time => {
          return time.getTime() > new Date( new Date(new Date().toLocaleDateString()).getTime() +24 * 60 * 60 * 1000 -1);
        },
      },
    };
  },
  methods: {
    getData(reset) {
      if (reset) this.pagination.currentPage = 1;
      this.isLoading = true;
      this.$request
        .get("adminUsrLog", {
          page: this.pagination.currentPage - 1,
          pagesize: this.pagination.pagesize,
          ...this.search,
          seachAction: this.searchActionSelect ? this.searchActionSelect : this.searchActionInput ? this.searchActionInput : '',
          i18n: this.$lang.currentLang,
          lang: this.$lang.currentLang,
          sdate: this.dateRange && this.dateRange[0] ? this.dateRange[0] : '',
          edate: this.dateRange && this.dateRange[1] ? this.dateRange[1] : ''
        })
        .then(res => {
          if (res.err == 0) {
            this.dataCode = res.dat.items
            this.pagination.total = res.dat.totalCount;
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.dataCode = [];
            this.pagination.total = 0;
          }
          this.isLoading = false;
        }).catch(() => {
          this.dataCode = [];
          this.pagination.total = 0;
          this.isLoading = false;
        });
    },
    getSelection() {
      this.$request
        .get("adminGetUDAction", {
          i18n: this.$lang.currentLang,
          lang: 'zh_CN',
        })
        .then(res => {
          if (res.err == 0) {
            this.selection = res.dat
          }
        });
    }
  },
  mounted() {
    this.getData();
    this.getSelection()
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.actionLog {

  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;

  .button {
    height: 48px;
    line-height: 48px;
    padding: 0 25px;
    margin-top: 0px;
    color: @primaryTextColor;
    background: transparent;
    border: none;
  }

  // margin: 24px 24px 50px 24px;
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .search {
    margin: 0px;
    align-self: flex-start;
    padding: 0px 0px 0 10px;
  }



  .section {
    // padding-bottom: 10px;
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: hidden;

    // .list-header {
    //   .title {
    //    font-size:16px;
    //    font-weight: bold;
    //    color: #333;
    //    letter-spacing: 1.5px;
    //     // .sc(24px, #333);
    //   }
    // }
    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }


  }

  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 6px;
    left: 10px;
    height: 24px;
    width: 24px;
    background: url(../../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  /deep/.el-date-editor .el-range-input {
    color: #fff;
    background-color: #222d35;
    width: 160px;
    line-height: 36px !important;
    height: 36px !important;
  }
}
</style>
<style lang="less">
/deep/.el-range__icon {
  margin-left: 25px;
}

/deep/.el-date-editor--daterange {
  color: #fff;
  background-color: #2b3842;

}

.el-date-editor .el-range-separator {
  color: #fff !important;
  width: 18%;
  line-height: 36px;
}


.select-date1.el-picker-panel {
  background-color: #222D35;
  border: none;
  padding-top: 10px;

  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222D35;
    }

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }

  .el-date-range-picker__header {
    color: #fff;
  }

  .in-range {
    background-color: #222D35;
  }

  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: @primaryTextColor;
    text-align: center;
  }

  .el-date-table td.today span {
    color: @primaryTextColor;
    font-weight: 700;
  }

  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }

  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }


  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background-color: @primaryTextColor;
    border: @primaryTextColor;
  }

  .el-date-table td.in-range {
    background-color: #222D35;
  }

  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }

  .el-date-table td {
    color: #fff
  }

  .el-date-table td.disabled div {
    background-color: #222D35 !important;
    color: #606266 !important;
  }
}

.actionLog {
  
  .search {
    display: flex;


    // #下拉选框#
    .select-search-recharge {
      background-color: rgb(34, 45, 53);
      box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
      border-radius: 4px;
      border: none;
      padding: 8px 0px;

      .el-select-dropdown__list {
        padding: 0px;
      }

      .el-select-dropdown__item {
        padding: 0px 16px;
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item.hover {
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
      }

      .el-select-dropdown__item.selected {
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item:hover {
        padding: 0px 16px;
        background: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      .el-select-dropdown__item.selected .select-label {
        padding: 0px;
      }

      // 对号
      .el-select-dropdown__item.selected:before,
      .el-select-dropdown__item.selected .select-label:before,
      .el-select-dropdown__item.selected.choose-num:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../assets/img/general/Icon_Duihao.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        position: absolute;
        top: 8px;
        right: 16px;
      }
    }

    .select-search-project {
      .el-select-dropdown__list {
        padding: 0 16px;
      }

      .el-select-dropdown__item {
        height: 40px;
        line-height: 40px;
        box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
      }
    }

    .selectClearNew {

      // 下拉选中清除按钮
      .el-icon-circle-close:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../assets/img/general/Icon_SelectClear.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        // position: absolute;
        // top: 8px;
        // right: 16px;
      }
    }


    .search-title {
      color: #fff;
      padding: 5px;
    }

    .el-select,
    .el-input {
      width: 165px;
      border-right: 1px solid #738089;

    }

    .el-input__inner {
      background: transparent;
      border: none;
      height: 36px;
      line-height: 36px;
      color: #ffffff;
      padding: 0 16px;
    }


  }

  .upload-button {
    width: 100%;
  }


}
</style>